"use client";

import { Alert, Box, Typography } from "@mui/material";
import { SellCreateForm } from "../create/SellCreateForm";
import Image from "next/image";
import { SELL_LANDING_CATEGORIES } from "../../SellLandingCategories";
import { CheckoutService } from "@/services/checkout/CheckoutService";
import { AD_CONFIG_STATE_DEFAULTS } from "@/sell/models/AdConfigState";
import { AD_DETAILS_DEFAULTS } from "@/sell/models/AdDetails";
import Link from "next/link";
import PillButton from "@/app/shared/PillButton";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export default function AdPricingPage() {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: "grey.100",
        paddingTop: 4,
        paddingBottom: 8,
        paddingLeft: 1,
        paddingRight: 1,
        [theme.breakpoints.down("sm")]: {
          paddingTop: 2,
        },
      })}
    >
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          gap: 4,
          maxWidth: "1200px",
          margin: "0 auto",
          [theme.breakpoints.down("sm")]: {
            gap: 2,
          },
        })}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            textAlign: "center",
          }}
        >
          Horsezone Classified Pricing
        </Typography>
        {SELL_LANDING_CATEGORIES.map((category) => {
          const hasDynamicPricing = !!CheckoutService.GetAdDynamicPrices({
            config: AD_CONFIG_STATE_DEFAULTS,
            details: AD_DETAILS_DEFAULTS,
            vertical: category.vertical,
          });
          return (
            <Box
              key={category.vertical}
              sx={{
                background: "white",
                padding: 4,
                display: "flex",
                flexDirection: "column",
                gap: 4,
                borderRadius: 2,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                }}
              >
                <Image
                  src={`/icons/categories/${category.icon}.png`}
                  alt={category.title}
                  unoptimized={true}
                  width={50}
                  height={50}
                />

                <Box>
                  <Typography variant="h6" component="h3">
                    {category.title}
                  </Typography>
                  <Typography variant="body2">
                    {category.subtitle.join(" ")}
                  </Typography>
                </Box>
              </Box>
              {hasDynamicPricing ? (
                <>
                  <Alert severity="info">
                    Pricing in this category depends on the details of your ad.
                    Please fill out the form below to see your personalized
                    pricing.
                  </Alert>
                  <SellCreateForm vertical={category.vertical} />
                </>
              ) : (
                <>
                  <Box>
                    {category.freeAdsBelow ? (
                      <>
                        <Typography>
                          less than {category.freeAdsBelow}: Free
                        </Typography>
                        <Typography>
                          greater than {category.freeAdsBelow}: from{" "}
                          {category.minimumAdCost}
                        </Typography>
                      </>
                    ) : (
                      <Typography>
                        All Ads: from {category.minimumAdCost}
                      </Typography>
                    )}
                  </Box>

                  <Box
                    component={Link}
                    href={`/sell/ad/create/${btoa(JSON.stringify({ vertical: category.vertical }))}`}
                    prefetch={false}
                    sx={{
                      alignSelf: "end",
                    }}
                  >
                    <PillButton
                      endIcon={<NavigateNextIcon />}
                      compactOnMobile
                      primary
                      type="submit"
                    >
                      Create Ad
                    </PillButton>
                  </Box>
                </>
              )}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
